import { request } from "@umijs/max";
import { ICurrentUser, ILoginParams } from "./data";

/** 获取当前的用户 */
export async function queryCurrentUser(options?: { [key: string]: any }) {
    return request<{
        data: ICurrentUser;
    }>("/api/user/currentUser", {
        method: "GET",
        ...(options || {}),
    });
}

/** 退出登录接口 */
export async function outLogin(options?: { [key: string]: any }) {
    return request<Record<string, any>>("/api/user/outLogin", {
        method: "POST",
        ...(options || {}),
    });
}

/** 登录接口 */
export async function login(
    body: ILoginParams,
    options?: { [key: string]: any }
) {
    return request<API.LoginResult>("/api/user/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        data: body,
        ...(options || {}),
    });
}
